/** Main quote line (UAE); same as primary WhatsApp contact for calls. */
const quoteCallNumber = "+971556177838";

/** WhatsApp: wa.me uses digits only (no + or spaces). */
const whatsappContacts = [
    {owner: "Mr. Muhammad Saeed", phoneDisplay: "+971506168540", waId: "971506168540"},
    {owner: "Mr. Bismillah", phoneDisplay: "+971556177838", waId: "971556177838"},
];

const ContactInfo = {
    contact_phone: "+971 50 616 8540",
    contact_email: "saeedanw443@gmail.com",
    address: "2 Street 49/1\n" +
        "Abu Dhabi\n" +
        "UAE",
    facebook: "https://tigerrefrigeratedtransport.com/",
    twitter: "https://tigerrefrigeratedtransport.com/",
    linkedin: "https://tigerrefrigeratedtransport.com/",
    instagram: "https://tigerrefrigeratedtransport.com/",
    youtube: "https://tigerrefrigeratedtransport.com/",
}


const teamMembers = [
    {id: 1, name: "Alice Smith", title: "Project Manager"},
    {id: 2, name: "Bob Johnson", title: "Software Engineer"},
    {id: 3, name: "Catherine Lee", title: "UX Designer"},
    {id: 4, name: "David Brown", title: "Data Analyst"},
    {id: 5, name: "Emily Davis", title: "Marketing Specialist"},
    {id: 6, name: "Frank Wilson", title: "Quality Assurance"},
    {id: 7, name: "Grace Taylor", title: "Content Strategist"},
    {id: 8, name: "Henry Moore", title: "DevOps Engineer"},

];

const data = [
    {
        id: 1,
        name: "Chiller Van - Car 1",
        image: "car-1",
        desc: "Reliable chiller van for fruits, vegetables, dairy, and fresh items with stable temperature during city and intercity delivery.",
        category: "Chiller Van",
        price: "600 AED / PerDay"
    },
    {
        id: 2,
        name: "Freezer Van - Car 2",
        image: "car-2",
        desc: "Professional freezer van for frozen products with dependable cooling and safe transport across Dubai and UAE routes.",
        category: "Freezer Van",
        price: "600 AED / PerDay"
    },
    {
        id: 3,
        name: "Freezer Truck - Car 3",
        image: "car-3",
        desc: "Heavy-duty freezer truck for bulk frozen cargo and long-route delivery with controlled low-temperature performance.",
        category: "Freezer Truck",
        price: "700 AED / PerDay"
    },
    {
        id: 4,
        name: "Chiller Truck - Car 4",
        image: "car-4",
        desc: "Chiller truck option for medium and large loads requiring cool-temperature transport and timely delivery service.",
        category: "Chiller Truck",
        price: "650 AED / PerDay"
    },
    {
        id: 5,
        name: "6 Ton Mover - Car 5",
        image: "mover-6ton",
        desc: "6 ton mover truck for commercial shifting and heavy cargo transport with reliable scheduling and careful handling.",
        category: "6 Ton Mover",
        price: "850 AED / PerDay"
    },
    {
        id: 6,
        name: "9 Ton Mover - Car 6",
        image: "mover-9ton",
        desc: "9 ton mover truck for large-scale moving and bulky loads across UAE routes with professional transport support.",
        category: "9 Ton Mover",
        price: "950 AED / PerDay"
    },
]

const server_ip = 'http://localhost:800'

export {ContactInfo, teamMembers, server_ip, data, whatsappContacts, quoteCallNumber}